import React from "react";
import "./RoomTypes.css";

const RoomTypes = () => {
  return (
    <>
      {/* Room Types Section */}
      <div className="room-types">
         <div className="hotel-slide-1"></div>
         <div className="hotel-slide-2_wrapper">
          <h1> Room Types</h1>
           <div className="hotel-slide-2">
        
  <div className="room-card">
    <div className="room-card-header">
      <span className="emoji">🛏️</span>
      <h1>Single Room</h1>
    </div>
    <p className="room-description">
      Ideal for solo travelers or working professionals, our Single Rooms offer a cozy haven with all essential comforts. Enjoy a plush bed, ambient lighting, and a workspace with high-speed Wi-Fi — perfect for unwinding or getting things done.
    </p>
  </div>

  <div className="room-card">
    <div className="room-card-header">
      <span className="emoji">👫</span>
      <h1>Double Room</h1>
    </div>
    <p className="room-description">
      Spacious and inviting, the Double Rooms are perfect for couples or small families. Featuring elegant interiors, soft linens, and warm wooden accents, these rooms provide a peaceful escape after a day of festivities or sightseeing.
    </p>
  </div>

  <div className="room-card">
    <div className="room-card-header">
      <span className="emoji">🛋️</span>
      <h1>Suite</h1>
    </div>
    <p className="room-description">
      Step into indulgence with our well-appointed Suites. These rooms offer a separate living area, king-size beds, premium toiletries, and elegant furnishing that adds a touch of grandeur to your stay. A perfect choice for couples or VIP guests attending events.
    </p>
  </div>

  <div className="room-card">
    <div className="room-card-header">
      <span className="emoji">👑</span>
      <h1>Premium Luxury Room</h1>
    </div>
    <p className="room-description">
      Designed to impress, our Premium Luxury Rooms blend modern design with traditional aesthetics. With panoramic views, smart lighting, rich textures, and upscale finishes, these rooms deliver a five-star experience — ideal for brides, grooms, or guests seeking exceptional comfort.
    </p>
  </div>
</div>
         </div>
      

        <div>
        </div>
 
      </div>

      {/* Interior Features Section */}
      <div className="interior-features">
        <div className="container-fluid">
          <h1> Interior Features</h1>
          <p className="intro">
            At Nandanam, our hotel rooms are designed to provide not just comfort,
            but a refined living experience. Every element is carefully selected
            to enhance your stay with elegance, warmth, and functionality.
          </p>

          <ul className="features-list">
            <li>
              🛏️ <strong>Cozy Beds:</strong> Sink into plush mattresses with crisp linens
              and soft pillows that guarantee restful sleep.
            </li>
            <li>
              💡 <strong>Ambient Lighting:</strong> Thoughtfully placed lighting creates a warm,
              relaxing atmosphere perfect for every mood.
            </li>
            <li>
              ❄️ <strong>Air Conditioning:</strong> Efficient and silent cooling ensures a pleasant
              environment no matter the weather.
            </li>
            <li>
              📶 <strong>Free High-Speed Wi-Fi:</strong> Seamless connectivity for both work and leisure,
              available in every room.
            </li>
            <li>
              🧑‍💼 <strong>Work Desk:</strong> A comfortable desk with power access to keep you productive
              during your stay.
            </li>
            <li>
              🚪 <strong>Spacious Wardrobe:</strong> Elegant, full-sized closets to store and organize
              your belongings with ease.
            </li>
            <li>
              🚿 <strong>Elegant Bathrooms:</strong> Modern fittings, premium toiletries, and spotless
              finishes create a spa-like experience.
            </li>
          </ul>

          <p className="closing">
            Whether you're preparing for a big event or winding down after a long day, our
            interiors offer a luxurious embrace that leaves you feeling refreshed and pampered.
          </p>
        </div>
      </div>
      <div className="booking-packages">
      <div className="container">
        <h1> Booking & Packages</h1>
        <p className="intro">
          At Nandanam, we believe in flexibility and convenience when it comes to booking your stay.
          Whether you're here for a few hours or a grand wedding weekend, we have packages tailored
          to your needs.
        </p>
 <div className="package-card_wrapper">
 <div className="package-card">
          <h3>⏱️ Hourly & Daily Rentals</h3>
          <p>
            Need a room for just a few hours between ceremonies? Or looking to stay for a night or two?
            Our hourly and daily rental options are designed to suit every kind of traveler — with
            complete access to amenities and services.
          </p>
        </div>

        <div className="package-card">
          <h3>👨‍👩‍👧‍👦 Group Packages for Weddings</h3>
          <p>
            Hosting your big day at Nandanam? Take advantage of our special group packages for families,
            wedding guests, and event attendees. We offer attractive rates for bulk room bookings and
            can customize packages based on your duration and guest count.
          </p>
        </div>

        <div className="package-card">
          <h3>📲 Easy Booking Options</h3>
          <p>
            Booking your room is quick and simple — reserve online through our website or get in touch
            with our hospitality team via phone. We're here to make your experience smooth, transparent,
            and hassle-free from the moment you plan your stay.
          </p>
        </div>
</div>
       

        <p className="closing">
          Whether it’s a short visit or a multi-day wedding celebration, our booking system ensures
          comfort, convenience, and great value at every step.
        </p>
      </div>
    </div>
    <div className="guest-reviews">
      <div className="container">
        <h1>Guest Reviews</h1>
        <p className="intro">
          Discover what our guests have to say about their experience at Nandanam.
          From elegant rooms to heartfelt hospitality, our reviews speak for themselves.
        </p>
<div className="review-card_wrapper">
   <div className="review-card">
          <p className="review-text">
            “Absolutely loved our stay during my cousin's wedding. The rooms were spotless, beds
            super comfy, and the staff was incredibly warm and helpful.”
          </p>
          <p className="review-author">— Priya M., Hyderabad</p>
        </div>

        <div className="review-card">
          <p className="review-text">
            “Nandanam exceeded our expectations! Beautiful interiors, peaceful ambience, and
            prompt room service. It felt like a home away from home.”
          </p>
          <p className="review-author">— Akshay R., Bengaluru</p>
        </div>

        <div className="review-card">
          <p className="review-text">
            “Stayed here for a family function. Impressed by the clean bathrooms, tasteful
            decor, and how attentive the hotel team was. Will return again!”
          </p>
          <p className="review-author">— Sneha K., Chennai</p>
        </div>
</div>
       

        <div className="review-rating">
          <span>⭐️⭐️⭐️⭐️☆</span>
          <p>4.6 out of 5 – Based on 250+ guest reviews</p>
        </div>

        <p className="closing">
          Book your stay with confidence. At Nandanam, every guest is treated like family.
        </p>
      </div>
    </div>
    </>
  );
};

export default RoomTypes;
